import axiosIntents from '@/utils/axios-intents'

import store from '@/store'
import axios from '@/utils/axios-intents'
import { db } from '@/utils/firebase'
import StoreCache from '@/utils/StoreCache'
import dynStorage from '@/utils/storage-dynamic'

import { 
    AVAILABLE_SIM_TYPE_PRODUCTS, 
    AVAILABLE_SIM_TYPE_PRODUCTS_BY_UUID, 
    logAnalyticsItems,

    eshopItem,
} from '@/helpers/eshop'

const cached = {
    fwa_plans: {
        uuids: {},
        lifetime: 5 * 60 * 1000, // 5 min
    },
    modems : {
        uuids: {},
        lifetime: 5 * 60 * 1000,// 5 min
    }
}

const FWA_SELECTED_PRODUCT = 'fwa-selected-product'
const ESHOP_V2_CART = 'eshop-v2-cart'
const ESHOP_V2_PURCHASED = 'eshop-v2-purchased'
const ESHOP_V2_CHECKOUT_FLOW = 'eshop-v2-checkout-flow'

const unsubscribes = {}
const unsubscribeAll = () => {
    for (const uuid in unsubscribes) {
        unsubscribes[ uuid ]()
        delete unsubscribes[ uuid ]
    }
}

const fwaPayloadFromBroadbandFlow = ({ uuid, location, transfer, service, plan, with_wifi_router, rsf, contact_phone }) => {
    const auth_user_profile_creds = store.getters.auth_user_profile_creds

    const payload = {
        UUID: uuid,
        SPID: store.getters.app_spid,
        CustomerUUID: store.getters.current_account_uid,
        Address: {
            ...(location ? {
                City: location.City,
                Country: location.Country,
                Postcode: location.PostCode,
                Lines: location.Lines,
                LocationProvider: location.LocationProvider,
                LocationProviderIDX: location.LocationProviderIDX,
            } : {}),
            // PrequalUUID: service.ID,
            Email: auth_user_profile_creds.email,
            Name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
            Phone: auth_user_profile_creds.phone,
        },
        ExternalReference: {
            ...(transfer && transfer?.required ? {
                OrderType: "TransferPrimary",
                TransferFrom: {
                    Provider: transfer.provider.name,
                    AccountHolderName: transfer.account.holder,
                    AccountNumber: transfer.account.number,
                    ConnectionID: transfer.connection.ID,
                },
            } : plan ? {
                OrderType: plan.OrderType,
            } : {}),
            ...(service ? {
                ServiceType: "Unmanaged",
                ServiceAvailabilityUUID: service.ID,
            } : {}),
            ...(rsf ? {
                RSFDate: rsf.StartTimeNanos,
            } : {}),
            SiteContactName: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
            SiteContactPhone: contact_phone || auth_user_profile_creds.phone,
            SiteContactEmail: auth_user_profile_creds.email,
            ...(location ? {
                LocationProvider: location.LocationProvider,
                LocationProviderIDX: location.LocationProviderIDX,
            } : {}),
        },
        Items: [],
    }

    if (plan) {
        payload.Items = [{
            ItemUUID: plan.ID,
            ProductAvailabilityUUID: plan.ID,
            SPID: store.getters.app_spid,
            Type: "TYPE_VIRTUAL",
            VirtualType: "VT_PLAN",
        }]

        if (with_wifi_router) {
            payload.Items.push({
                ItemUUID: plan.ID,
                ProductAvailabilityUUID: plan.ID,
                SPID: store.getters.app_spid,
                Type: "TYPE_PRODUCT",
                VirtualType: "VT_NONE"
            })
        }
    }

    return payload
}

const state = {
    fwa_products: [],
    fwa_product_uuid: null,
    eshop_v2_fwa_cart_loading: false,
}

const getters = {
    fwa_product: state => state.fwa_products.find(fwa_product => fwa_product.UUID == state.fwa_product_uuid),
    fwa_products: state => state.fwa_products || [],
    eshop_v2_fwa_purchased: state => state.eshop_v2_fwa_purchased,
}

const mutations = {
    saveFWAProducts(state, fwa_products) {
        state.fwa_products = fwa_products || []
    },

    selectFirstFWAProduct(state) {
        if (state.fwa_products.length) {
            if (!state.fwa_product_uuid) {
                state.fwa_product_uuid = dynStorage.get(FWA_SELECTED_PRODUCT)
            }

            if (!(state.fwa_product_uuid && state.fwa_products.findIndex(fwa_product => fwa_product.UUID == state.fwa_product_uuid) > -1)) {
                state.fwa_product_uuid = state.fwa_products[0].UUID
            }
        } else {
            state.fwa_product = null
            state.fwa_product_uuid = null
        }
    },


    eshopPurchasedReset_v2(state) {
        state.eshop_v2_fwa_purchased = null

        dynStorage.remove(ESHOP_V2_PURCHASED)
    },
}

const actions = {
    fwaSearchAddress({}, payload) {
        return axios.get('/fwa/searchAddress', { params: payload })
            .then(({data}) => Promise.resolve(data))
    },

    fwaServiceAvailability({getters}, Location) {
        const payload = {
            SPID: getters.app_spid,
            LocationProvider: Location.LocationProvider,
            //LocationProviderIDX: Location.LocationProviderIDX,
            LocationProviderIDX: "ChIJvciLkwA5DW0Rtfzp4Ztf2mY",
        }

        return axios.get('/fwa/service_availability', { params: payload }).then(({data}) => {
            return data.Status == 'service_available'
                || data.Status == 'service_scope_required'
                || data.Status == 'service_installation_required'
                    ? Promise.resolve(data)
                    : Promise.reject(new Error('No Fibre services available'))
        })
    },

    fwaChangePlan({getters}, { UUID, ProductAvailabilityUUID }) {
        const payload = {
            UUID,
            ProductAvailabilityUUID,
            CustomerUUID: getters.current_account_uid,
        }

        return axios.post('/fwa/change-plan', payload)
    },

    fwaCart({commit}, broadband_flow) {
        return axios.post('/eshop/v2/cart', fwaPayloadFromBroadbandFlow(broadband_flow))
    },

    fwaCheckout({getters, commit, dispatch}, broadband_flow) {
        return axios.post('/eshop/v2/checkout', fwaPayloadFromBroadbandFlow(broadband_flow)).then(({data}) => {
            return getters.is_checkout_payment_confirmation && data?.ClientSecret
                ? dispatch('stripePaymentConfirmation', {
                    card_token: broadband_flow.payment_method?.cardId || getters.defaultPaymentCardId,
                    client_secret: data.ClientSecret,
                }).then(() => {
                    commit('resetBroadbandFlow')

                    return Promise.resolve(data)
                }).catch(error => {
                    error.srtripe_client_secret = data.ClientSecret

                    return Promise.reject(error)
                })
                : Promise.resolve(data)
        }).then(data => {
            return data?.OrderID
                ? dispatch('fwaCheckoutOrderStatus', data.OrderID)
                : Promise.resolve(data)
        }).then(() => {
            const PrequalUUID = broadband_flow?.service?.ID // fwaPayloadFromBroadbandFlow(broadband_flow) => ExternalReference.ServiceAvailabilityUUID || Address.PrequalUUID
            
            return PrequalUUID
                ? dispatch('fwaCheckSubscribeProduct', PrequalUUID)
                : Promise.resolve()
        })
    },

    fwaCheckoutOrderStatus({getters, dispatch}, OrderID) {
        return axios.get(`/eshop/v2/customer/${ getters.current_account_uid }/order/${ OrderID }`).then(({data}) => {
            return data?.Status
                ? data.Status == 'COMPLETED' || data.Status == 'PROCESSING'
                    ? Promise.resolve(data)
                    : data.Status == 'FAILED'
                        ? Promise.reject({
                            message: data?.OrderNotes?.[0]?.Note || 'Order failed',
                            order_status: true
                        })
                        : new Promise((resolve, reject) => {
                            setTimeout(() => {
                                dispatch('fwaCheckoutOrderStatus', OrderID)
                                    .then(data => resolve(data))
                                    .catch(error => reject(error))
                            }, 250)
                        })
                : Promise.resolve(data)
        })
    },

    fwaCheckSubscribeProduct({getters, commit, dispatch}, PrequalUUID) {
        const timeout = new Date().getTime() + (3 * 60 * 1000) // 3 min

        return dispatch('fwaSubscribeProducts').then(() => new Promise(resolve => {
            const interval = setInterval(() => {
                const fwa_product = getters.fwa_products.find(fwa_product => fwa_product.PrequalUUID == PrequalUUID)

                switch (true) {
                    case Boolean(fwa_product): {
                        commit('selectFWAProduct', fwa_product.UUID)
                    }

                    case new Date() > timeout: {
                        clearInterval(interval)
                        resolve()
                    }
                }
            }, 250)
        }))
    },

    fwaSubscribeProducts({getters, commit}) {
        const uuid = getters.current_account_uid

        if (uuid) {
            if (!(uuid in unsubscribes)) {
                unsubscribeAll()

                return new Promise(resolve => {
                    unsubscribes[uuid] = db.collection(`/customers/${ uuid }/fwa_products`).onSnapshot(collection => {
                        const fwa_products = []
    
                        collection.forEach((doc) => {
                            const fwa_product = doc.data()
    
                            if (!fwa_product.DeletedAtNanos) {
                                fwa_products.push(fwa_product)
                            }
                        })
    
                        commit('saveFWAProducts', fwa_products)
                        commit('selectFirstFWAProduct')

                        resolve(getters.fwa_products)
                    })
                })
            }
        } else {
            return Promise.resolve([])
        }
    },

    fwaUnsubscribeProducts() {
        unsubscribeAll()
    },

    fwaOrderTimeSlots({getters}, { OrderUUID, Mode }) {
        const params = {
            OrderUUID,
            CustomerUUID: getters.current_account_uid,
            Mode,
        }

        return axios.get(`/fwa/order/${ OrderUUID }/time_slots`, { params })
                    .then(({data}) => Promise.resolve(data?.AvailableTimeSlots || []))
    },

    fwaBookOrderAppointment({getters}, payload) {
        if (!payload.SPID) {
            payload.SPID = getters.app_spid
        }

        return axios.post(`/fwa/order/${ payload.UUID }/book`, payload)
            .then(({data}) => Promise.resolve(data))
    },

    async getFwaPlans({commit}, { customer_uuid, product_uuid, force_refresh }) {

        console.log('getFwaPlans', customer_uuid, product_uuid, force_refresh)

        if (!force_refresh && 
            Object.keys(cached.fwa_plans.uuids).length > 0 && 
            !Object.values(cached.fwa_plans.uuids).some(cache => cache.expired()) ) {
            
                return Promise.resolve(
                    Object.values(cached.fwa_plans.uuids)
                    .map(cache => cache.cachedData())
                    .filter(Boolean)
                )

        } else {


            try {
                const fwa_plans_data = await axiosIntents.get(`fwa/v1/customer/${customer_uuid}/mobile/${product_uuid}/plans`)
                console.log('fwa_plans_data', fwa_plans_data)

                if (fwa_plans_data?.data?.BroadbandPlans?.Plans?.length > 0 && Array.isArray(fwa_plans_data.data.BroadbandPlans.Plans)) {
                    const BroadbandPlans = fwa_plans_data.data.BroadbandPlans.Plans
                    BroadbandPlans.forEach(BroadbandPlan => {
                        const uuid = `${ customer_uuid }|${ BroadbandPlan.ID }`

                        if (!cached.fwa_plans.uuids[uuid]) {
                            cached.fwa_plans.uuids[uuid] = new StoreCache(cached.fwa_plans.lifetime)
                        }

                        cached.fwa_plans.uuids[uuid].fix(BroadbandPlan)

                    })

                    return Promise.resolve(
                        Object.values(cached.fwa_plans.uuids)
                            .map(cache => cache.cachedData())
                            .filter(Boolean)
                    )

                } else {
                    console.log('no FWA Plans data')
                    return Promise.reject('No FWA Plans data')
                }

            } catch (error) {
                console.log(error)
                return Promise.reject(error)
            }
        }
    },

    async getFWAModems({commit, getters}, force_refresh = true) {

        if (!force_refresh && 
            Object.keys(cached.modems.uuids).length > 0 && 
            !Object.values(cached.modems.uuids).some(cache => cache.expired()) ) {
            
                return Promise.resolve(
                    Object.values(cached.modems.uuids)
                    .map(cache => cache.cachedData())
                    .filter(Boolean)
                )

        } else {

            const params = {
                "SearchOptions": {
                    "PageNumber": 1,
                    "PageSize": 10,
                    "SortBy": "Name",
                    "SortDesc": true,
                },
                "IncludeDeleted": false,
                "SPID": getters.app_spid,
                "FacetFilters": [{
                    "Name": "NetworkType",
                    "Values": ["FWA"] //"UFB" for UFB
                }]
            }

            try {
                const modem_data = await axiosIntents.post('eshop/eshop_item_advanced_search', params)

                if (modem_data?.data?.ItemVariants?.length > 0 && Array.isArray(modem_data.data.ItemVariants)) {

                    const ItemVariants = modem_data.data.ItemVariants
                    const modems = []

                    ItemVariants.forEach(itemVariant => {

                        const modem = {
                            UUID: itemVariant.UUID,
                            ItemVariantUUID: itemVariant.UUID,
                            ItemUUID: itemVariant.ItemUUID,
                            ItemImages: itemVariant.ItemImages || [],
                            Name: itemVariant.Name,
                            Price: null,
                            PhysicalType: "MODEM",
                            ServiceType: "FWA",
                            Description: itemVariant.Description ?? null,
                            Attributes: []
                        }

                        if (Array.isArray(itemVariant.ItemVariantAttributes)) {

                            itemVariant.ItemVariantAttributes.forEach(attr => {
                                const { Name, Value, ShowToCustomer } = attr

                                if (!Value || Value.trim() === '') return

                                if (Name === "Price" && !modem.Price) {
                                    modem.Price = Value
                                }

                                if (ShowToCustomer === true && Name !== "Price") {
                                    modem.Attributes.push({Name, Value})
                                }                               
                            })
                        }

                        modems.push(modem)
                    })

                    modems.forEach(modem => {
                        //update cache service
                        const uuid = `${ modem.UUID }|${ modem.ItemVariantUUID }`
                        if (!cached.modems.uuids[uuid]) {
                            cached.modems.uuids[uuid] = new StoreCache(cached.modems.lifetime)
                        }

                        cached.modems.uuids[uuid].fix(modem)
                    })

                    return Promise.resolve(
                        Object.values(cached.modems.uuids)
                            .map(cache => cache.cachedData())
                            .filter(Boolean)
                    )
                    
                } else {
                    console.log('no modem data')
                    return Promise.reject('No modem data')
                }
            } catch (error) {
                console.log(error)
                return Promise.reject(error)
            }
        }
    },




}

export default {
	state,
	getters,
	mutations,
	actions,
}